<div class="container-fluid glb-popup ctm-expense-popup" [class.my-2]="!isDialogMode" style="max-width: 1200px !important; position: relative;">
  <h2 [class.mt-2]="isDialogMode"> {{formTitle}} @if (expenseId) {
    <span class="text-muted small">- {{expenseId}}</span>
  }</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  @if (formLoading) {
    <div style="position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,0.7);display:flex;align-items:center;justify-content:center;z-index:9999;">
      <i class="pi pi-spin pi-spinner" style="font-size:2.5rem;color:#6c757d;"></i>
    </div>
  }

  @if (isDialogMode) {
    <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  }
  <mat-tab-group class="tabs-group edit-order-grp">
    <mat-tab label="Expense">
      <div [formGroup]="form1" class="forms w-100 d-block">
        <div class="row m-0">
          <div class="col-lg-12">
            @if (formAlert) {
              <div class="w-100 mb-3">
                <div class="w-100"
                  style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                  <p><b>{{formAlert}}</b></p>
                </div>
              </div>
            }
          </div>
          <div class="d-flex gap-2 show-statement-mobile mt-2">
            @if (!expenseId) {
              <div class="col-lg-6"></div>
            }
            @if (expenseId) {
              <div>
                <label>Show To Statement : </label>
              </div>
            }
            @if (expenseId) {
              <div>
                <span class="p-float-label required-field w-100">
                  <p-inputSwitch (onChange)="formUpdate()" formControlName="showToStmt">
                  </p-inputSwitch>
                  @for (validation of validationMessages.showToStmt; track validation) {
                    <span>
                      @if (form1.get('showToStmt').hasError(validation.type) && (form1.get('showToStmt').dirty || form1.get('showToStmt').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            }
          </div>
          <div class="inner-divs-grid-wrapper mb-4">
            <div>
              <div class="title popup-title">
                <h4>Expense Basics</h4>
              </div>
              <div class="inner-divs-grid">
                <div class="items">
                  <span class="p-float-label w-100 mb-3">
                    <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="statuses"
                      formControlName="status" optionLabel="name" optionValue="value"
                    placeholder="Status"></p-dropdown>
                    <label for="Status">Status</label>
                    @for (validation of validationMessages.status; track validation) {
                      <span>
                        @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                <div class="items">
                  <span class="p-float-label required-field w-100">
                    <p-dropdown dropdownIcon="fa fa-caret-down" [options]="properties"
                      formControlName="shortTermRentalId" optionLabel="propertyCode"
                      optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode"
                      [showClear]="false" placeholder="Select Property">
                    </p-dropdown>
                    <label for="Select Property">Select Property <span
                    style="color: red">*</span></label>
                  </span>
                  @for (validation of validationMessages.shortTermRentalId; track validation) {
                    <span>
                      @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </div>
                <div class="items">
                  <span class="p-float-label required-field w-100">
                    <input formControlName="name" id="name" type="text" pInputText>
                    <label for="name">Task <span style="color: red">*</span></label>
                  </span>
                  @for (validation of validationMessages.name; track validation) {
                    <span>
                      @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </div>
                <div class="items mb-3">
                  <span class="p-float-label w-100">
                    <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100"
                      [options]="expenseCategories" formControlName="expenseCategory"
                      optionLabel="name" optionValue="value"
                    placeholder="Expense Category"></p-dropdown>
                    <label for="expenseCategory">Expense Category <span
                    style="color: red">*</span></label>
                  </span>
                  @for (validation of validationMessages.expenseCategory; track validation) {
                    <span>
                      @if (form1.get('expenseCategory').hasError(validation.type) && (form1.get('expenseCategory').dirty || form1.get('expenseCategory').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </div>
                <div class="items big">
                  <span class="p-float-label w-100 mb-3">
                    <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="priorities"
                      formControlName="priority" optionLabel="name" optionValue="value"
                    placeholder="Priority"></p-dropdown>
                    <label for="priority">Priority</label>
                    @for (validation of validationMessages.priority; track validation) {
                      <span>
                        @if (form1.get('priority').hasError(validation.type) && (form1.get('priority').dirty || form1.get('priority').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>
            </div>

            <div>
              <div class="title popup-title">
                <h4>Dates & Timing</h4>
              </div>
              <div class="inner-divs-grid">
                <div class="items">
                  <span class="p-float-label w-100 mb-3">
                    <p-calendar appendTo="body" formControlName="expenseDate" inputId="expenseDate">
                    </p-calendar>
                    <label for="expenseDate">Expense Date</label>
                    @for (validation of validationMessages.expenseDate; track validation) {
                      <span>
                        @if (form1.get('expenseDate').hasError(validation.type) && (form1.get('expenseDate').dirty || form1.get('expenseDate').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                <div class="items">
                  <span class="p-float-label w-100 mb-3">
                    <p-calendar appendTo="body" formControlName="stmtBilledDate"
                      inputId="stmtBilledDate">
                    </p-calendar>
                    <label for="stmtBilledDate">Statement Billed Date</label>
                    @for (validation of validationMessages.stmtBilledDate; track validation) {
                      <span>
                        @if (form1.get('stmtBilledDate').hasError(validation.type) && (form1.get('stmtBilledDate').dirty || form1.get('stmtBilledDate').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                <div class="items">
                  <span class="p-float-label w-100 mb-3 ctm-expense-calender">
                    <p-calendar appendTo="body" formControlName="workOrderCreateDate"
                      inputId="workOrderCreateDate">
                    </p-calendar>
                    <label for="workOrderCreateDate">WorkOrder Create Date</label>
                    @for (validation of validationMessages.workOrderCreateDate; track validation) {
                      <span>
                        @if (form1.get('workOrderCreateDate').hasError(validation.type) && (form1.get('workOrderCreateDate').dirty || form1.get('workOrderCreateDate').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                <div class="items">
                  <span class="p-float-label w-100 mb-3">
                    <p-calendar appendTo="body" formControlName="scheduledDateTime"
                    inputId="scheduledDateTime" [showTime]="true" [hourFormat]="'24'"></p-calendar>
                    <label for="scheduledDateTime">Scheduled Date Time</label>
                    @for (validation of validationMessages.scheduledDateTime; track validation) {
                      <span>
                        @if (form1.get('scheduledDateTime').hasError(validation.type) && (form1.get('scheduledDateTime').dirty || form1.get('scheduledDateTime').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                <div class="items">
                  <span class="p-float-label w-100 mb-3 ctm-expense-calender">
                    <p-calendar appendTo="body" formControlName="startDateTime" inputId="startDateTime"
                    [showTime]="true" [hourFormat]="'24'"></p-calendar>
                    <label for="startDateTime">Start Date Time</label>
                    @for (validation of validationMessages.startDateTime; track validation) {
                      <span>
                        @if (form1.get('startDateTime').hasError(validation.type) && (form1.get('startDateTime').dirty || form1.get('startDateTime').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                <div class="items">
                  <span class="p-float-label w-100 mb-3">
                    <p-calendar appendTo="body" formControlName="completedDate" inputId="completedDate">
                    </p-calendar>
                    <label for="completedDate">Completed Date </label>
                    @for (validation of validationMessages.completedDate; track validation) {
                      <span>
                        @if (form1.get('completedDate').hasError(validation.type) && (form1.get('completedDate').dirty || form1.get('completedDate').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                <div class="items">
                  <span class="p-float-label w-100 mb-3 ctm-expense-calender">
                    <p-calendar appendTo="body" formControlName="vendorUpdateDateTime"
                      inputId="vendorUpdateDateTime" [showTime]="true"
                    [hourFormat]="'24'"></p-calendar>
                    <label for="vendorUpdateDateTime">Vendor Update Date Time</label>
                    @for (validation of validationMessages.vendorUpdateDateTime; track validation) {
                      <span>
                        @if (form1.get('vendorUpdateDateTime').hasError(validation.type) && (form1.get('vendorUpdateDateTime').dirty || form1.get('vendorUpdateDateTime').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                <div class="items big">
                  <span class="p-float-label w-100 mb-3">
                    Create Date: {{expense?.createDate | date:'MM/dd/yyyy'}}
                  </span>
                </div>
                <div class="items big">
                  <span class="p-float-label w-100 mb-3">
                    Last Update Date: {{expense?.lastUpdate | date:'MM/dd/yyyy'}}
                  </span>
                </div>
              </div>
            </div>

            <div>
              <div class="title popup-title">
                <h4>People Involved</h4>
              </div>
              <div class="inner-divs-grid">
                <div class="items mb-3">
                  <span class="p-float-label w-100">
                    <input formControlName="assignedToName" id="assignedToName" type="text" pInputText>
                    <label for="assignedToName">Assigned To Name</label>
                  </span>
                  @for (validation of validationMessages.assignedToName; track validation) {
                    <span>
                      @if (form1.get('assignedToName').hasError(validation.type) && (form1.get('assignedToName').dirty || form1.get('assignedToName').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </div>
                <div class="items mb-3">
                  <span class="p-float-label w-100">
                    <input formControlName="createdByUserName" id="createdByUserName" type="text"
                      pInputText>
                      <label for="createdByUserName">Created By UserName&nbsp;<span class="text-danger">*</span></label>
                    </span>
                    @for (validation of validationMessages.createdByUserName; track validation) {
                      <span>
                        @if (form1.get('createdByUserName').hasError(validation.type) && (form1.get('createdByUserName').dirty || form1.get('createdByUserName').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </div>
                  <div class="items">
                    <span class="p-float-label w-100 mb-3">
                      <input formControlName="requestedBy" id="requestedBy" type="text" pInputText>
                      <label for="requestedBy">Requested By</label>
                      @for (validation of validationMessages.requestedBy; track validation) {
                        <span>
                          @if (form1.get('requestedBy').hasError(validation.type) && (form1.get('requestedBy').dirty || form1.get('requestedBy').touched)) {
                            <small class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                  </div>
                  <div class="items">
                    <span class="p-float-label w-100 mb-3">
                      <input formControlName="completedByUserName" id="completedByUserName" type="text"
                        pInputText>
                        <label for="completedByUserName">Completed By UserName</label>
                        @for (validation of validationMessages.completedByUserName; track validation) {
                          <span>
                            @if (form1.get('completedByUserName').hasError(validation.type) && (form1.get('completedByUserName').dirty || form1.get('completedByUserName').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="title popup-title">
                    <h4>Vendor Info</h4>
                  </div>
                  <div class="inner-divs-grid">
                    <div class="items">
                      <span class="p-float-label w-100 mb-3">
                        <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="vendors"
                          formControlName="expenseVendor" optionLabel="name" optionValue="value"
                        placeholder="Expense Vendor"></p-dropdown>
                        <label for="expenseVendor">Expense Vendor</label>
                        @for (validation of validationMessages.expenseVendor; track validation) {
                          <span>
                            @if (form1.get('expenseVendor').hasError(validation.type) && (form1.get('expenseVendor').dirty || form1.get('expenseVendor').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                    <div class="items">
                      <span class="p-float-label required-field w-100 mb-3">
                        <input formControlName="expenseVendorId" id="expenseVendorId" type="text"
                          pInputText>
                          <label for="expenseVendorId">Expense Vendor Id</label>
                        </span>
                      </div>
                      <div class="items">
                        <!-- <div class="vendor-report-url-wrap">
                        <span class="p-float-label required-field w-100 mb-3">
                          <input formControlName="vendorReportUrl" id="vendorReportUrl" type="text"
                            pInputText>
                            <label for="vendorReportUrl">Vendor Report Url</label>
                          </span> -->
                          <button type="button" pButton label="View Vendor Report" class="p-button-sm p-button-outlined vendor-report-open-btn"
                            [disabled]="!form1.get('vendorReportUrl')?.value"
                          (click)="openVendorReportUrl()"></button>
                        <!-- </div> -->
                      </div>
                      <div class="items">
                        <span class="p-float-label required-field w-100 mb-3">
                          <input formControlName="topicId" id="topicId" type="number" pInputText>
                          <label for="topicId">TopicId</label>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="title popup-title">
                    <h4>Vendor Info</h4>
                  </div>
                  <div class="inner-divs-grid">
                    <div class="items">
                      <span class="p-float-label w-100 mb-3">
                        <textarea formControlName="description" id="description" [rows]="2"
                        pInputTextarea></textarea>
                        <label for="description">Description</label>
                        @for (validation of validationMessages.description; track validation) {
                          <span>
                            @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                    <div class="items">
                      <span class="p-float-label w-100 mb-3">
                        <textarea formControlName="changeLog" id="changeLog" [rows]="2" readonly="true"
                        pInputTextarea></textarea>
                        <label for="changeLog">Change Log</label>
                        @for (validation of validationMessages.changeLog; track validation) {
                          <span>
                            @if (form1.get('changeLog').hasError(validation.type) && (form1.get('changeLog').dirty || form1.get('changeLog').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                  </div>
                </div>
                <div class="d-flex gap-2 show-statement-desktop mt-2">
                  @if (!expenseId) {
                    <div class="col-lg-6"></div>
                  }
                  @if (expenseId) {
                    <div>
                      <label>Show To Statement : </label>
                    </div>
                  }
                  @if (expenseId) {
                    <div>
                      <span class="p-float-label required-field w-100">
                        <p-inputSwitch (onChange)="formUpdate()" formControlName="showToStmt">
                        </p-inputSwitch>
                        @for (validation of validationMessages.showToStmt; track validation) {
                          <span>
                            @if (form1.get('showToStmt').hasError(validation.type) && (form1.get('showToStmt').dirty || form1.get('showToStmt').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                  }
                </div>
              </div>
            </div>
            @if (expenseId) {
              <app-expense-detail-list [expenseId]="expenseId"></app-expense-detail-list>
            }
            <hr>
              <div class="row m-0">
                <div class="col-lg-12">
                  <div class="btn-group">
                    <div class="button-group">
                      @if (expenseId) {
                        <button pButton class="btn-delete p-button-outlined p-button-danger"
                        [class.disabled]="isDeleting" (click)="onFormDelete()">{{!isDeleting ? 'Delete' : 'Deleting...'}}</button>
                      }
                    </div>

                    <div class="button-group">
                      <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                      @if (!expenseId) {
                        <button pButton [class.disabled]="formLoading" class="btn-addt p-button"
                          (click)="formAdd()">
                          {{!formLoading ? 'Add' : 'Adding...'}}
                        </button>
                      }

                      @if (expenseId) {
                        <button pButton [class.disabled]="formLoading" class="btn-upt p-button"
                          (click)="formUpdate()">
                          {{!formLoading ? 'Update' : 'Updating...'}}
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>

            <mat-tab label="History">
              @if (expenseId) {
                <app-audit-list [auditUrl]="'expenses/' + expenseId + '/audit'"></app-audit-list>
              }
            </mat-tab>

          </mat-tab-group>

        </div>

